<div id="main-container">
  <router-outlet/>
</div>

